export default class StoreFilterService {
    getFilteredStores(filters, stores) {
        let filteredStores = stores;

        for (const filterKey in filters) {
            if (filters[filterKey].length == 0) continue;

            if (filterKey != 'categories') {
                filteredStores = filteredStores.filter(store => {
                    return store[filterKey].some(attribute => filters[filterKey].includes(attribute.id));
                });

                continue;
            }
        }

        return filteredStores;
    }

    /**
	  * Should be same as "getFiltersFromUrl" in ProductFilterService by Gabriel Vadkerti
	  * @param {*} filterData options for filters, see store
	  * @param {*} filters currently applied filters, see store
	  * @returns sets filters upon startup
	  */
    getFiltersFromUrl(filterData, filters) {
        if (!window.location.pathname.includes('/f/')) return filters;

        const queryStringArr = window.location.pathname.split('/f/')[1].split('/');

        for (const queryString of queryStringArr) {
            for (const filterKey in filterData) {
                const filter = filterData[filterKey].find(filter => filter.slug == queryString);
                if (filter) {
                    filters[filterKey].push(filter.id);
                }
            }
        }

        return filters;
    }

    /**
	  * Should be same as "getQueryFilters" in ProductFilterService by Gabriel Vadkerti
	  * @param {*} filterData options for filters, see store
	  * @param {*} filters currently applied filters, see store
	  * @returns returns filters array in string/slug format
	  */
    getQueryFilters(filters, filterData) {
        const queryArr = [];

        for (const key in filters) {
            for (const filterId of filters[key]) {
                queryArr.push(filterData[key].find(f => f.id == filterId).slug);
            }
        }

        return queryArr.length > 0 ? queryArr.join('/') : '';
    }   
}